import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const EuroIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M17 4.78242C15.7616 3.67399 14.1262 3 12.3333 3C8.46734 3 5.33333 6.13401 5.33333 10C5.33333 13.866 8.46734 17 12.3333 17C14.1262 17 15.7616 16.326 17 15.2176M3 8.44444H12.3333M3 11.5556H12.3333"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </SvgIcon>
    );
};
